import { useCallback } from "react";
import { t as translate, type Lang, type TRANSLATIONS } from "../lib/i18n";

// Sozluk anahtari. t()'yi prop olarak alan alt bilesenler (orn. Login.tsx
// icindeki PasswordField) imzayi yazabilsin diye disa acik.
export type Key = keyof typeof TRANSLATIONS;

// Uygulama yalnizca Ingilizce. Dil secimi/TR tamamen kaldirildi; bu hook
// geriye uyumluluk icin ayni API'yi (lang, setLang, toggle, t) dondurur ama
// dil her zaman "en". setLang/toggle no-op.
const LANG: Lang = "en";

if (typeof document !== "undefined") {
  document.documentElement.lang = LANG;
}
if (typeof localStorage !== "undefined") {
  // Eski TR tercihini temizle.
  try {
    localStorage.setItem("lang", LANG);
  } catch {
    /* ignore */
  }
}

const noop = () => {};

export function useLang() {
  const t = useCallback((key: Key) => translate(key, LANG), []);
  return { lang: LANG, setLang: noop, toggle: noop, t };
}
